import { l10nEnService } from '@uplift/services';
import { InsuranceCompany } from '@uplift/types';

export const sessionPay = 'sessionPay';
export const sessionPayUUID = '00000000-0000-0000-0000-000000000000';


export const cashPay = {
  id: sessionPayUUID,
  humanId: sessionPay,
  name: l10nEnService.onboarding.insurance.sessionPay,
  logo: '',
};

export const sessionPayCompany: InsuranceCompany = {
  id: sessionPayUUID,
  name: l10nEnService.onboarding.insurance.sessionPay,
  logo: '',
  createdAt: '',
  shortName: l10nEnService.onboarding.insurance.selfPay,
  updatedAt: '',
  url: '',
  key: ''
};
